import React from 'react';

const BeneficiosEneaCoaching = () => {
  return (
    <div className="section-container">
      <h2>Beneficios del EneaCoaching</h2>
      <p>
        El EneaCoaching ofrece numerosos beneficios para el desarrollo personal y profesional. Algunos de los principales son:
      </p>

      <div className="tipos-eneagrama-container">
        <h4>- Autoconocimiento profundo y revelador</h4>
        <p>
          Al identificar tu tipo de personalidad según el Eneagrama, podrás comprender tus comportamientos, emociones y motivaciones subyacentes, lo que te permitirá tomar decisiones más conscientes.
        </p>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>- Mayor claridad en objetivos y propósito</h4>
        <p>
          Con las herramientas de Coaching, podrás definir metas claras y alineadas con tu propósito de vida.
        </p>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>- Desarrollo personal integral</h4>
        <p>
          El EneaCoaching te permite trabajar en todos los aspectos de tu ser, ayudando a mejorar la gestión emocional, la toma de decisiones, las relaciones interpersonales y la productividad.
        </p>
      </div>

      <div className="tipos-eneagrama-container">
        <h4>- Mayor bienestar y equilibrio</h4>
        <p>
          A través del trabajo con los tres centros de inteligencia, lograrás un equilibrio que te permitirá sentirte más centrado y en paz.
        </p>
      </div>

      <p>
        En resumen, el EneaCoaching es un proceso de acompañamiento único que no solo te ayuda a alcanzar metas concretas, sino que también transforma tu manera de ser y estar en el mundo, alineándote con tu verdadero propósito.
      </p>

      <button
            className="btn-contacto"
            onClick={() => {
                window.open(
                "https://wa.me/34696667110?text=Hola. Quiero información sobre EneaCoaching.",
                "_blank"
                );
            }}
            >
            Consulta más sobre EneaCoaching
            </button>
    </div>
  );
};

export default BeneficiosEneaCoaching;
